import { z } from "zod/v4";

import {
  InternalOrganizationDtoSchema,
  OrganizationDtoSchema,
} from "../../../dtos/organizations";
import { castToBool } from "../../../utils";

export const GetOrganizationRequestQueryParamSchema = z.object({
  chargeId: z.string().optional(),
  code: z.string().optional(),
  viewAs: castToBool.optional(),
  viewAsProductId: z.string().optional(),
});

export type GetOrganizationRequestQueryParamType = z.infer<
  typeof GetOrganizationRequestQueryParamSchema
>;

export const InternalGetOrganizationRequestPathParamSchema = z.object({
  organizationId: z.uuid(),
});

export type InternalGetOrganizationRequestPathParamType = z.infer<
  typeof InternalGetOrganizationRequestPathParamSchema
>;

export const GetOrganizationResponseBodySchema = z.object({
  org: OrganizationDtoSchema,
});

export type GetOrganizationResponseBodyType = z.infer<
  typeof GetOrganizationResponseBodySchema
>;

export const GetInternalOrganizationResponseBodySchema = z.object({
  org: InternalOrganizationDtoSchema,
});

export type GetInternalOrganizationResponseBodyType = z.infer<
  typeof GetInternalOrganizationResponseBodySchema
>;
